import './Onboarding.css';
import OnboardingMobileContent from "./OnboardingMobileContent/OnboardingMobileContent";
import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from '@fortawesome/free-solid-svg-icons'
import { isMobile } from 'react-device-detect';
import PageDots from '../PageDots/PageDots';
import BrandLogo from '../../media/ec-reydar-combined-logo.png';
const Onboarding = ({setHelpScreenVisible}) => {

    async function GetOnboardingData(){ 
        if (isMobile) {
            let response = await fetch("./data/onboardingContentsMobile.json");
            setOnboardingContents(await response.json());
        } else {
            let response = await fetch("./data/onboardingContentsDesktop.json");
            setOnboardingContents(await response.json());
        }
        setPageIndex(0);
        setDataLoaded(true);
    };

    useEffect(() => {
         GetOnboardingData()}, []);

    
    const [onboardingContents, setOnboardingContents] = useState(null);
    const [pageIndex, setPageIndex] = useState(null);
    const [dataLoaded, setDataLoaded] = useState(false);
    
    const buttonClickHandler = function() {
        goToNextPage();
    }

    const goToNextPage = () => {
        if ((pageIndex + 1) > onboardingContents.length - 1) {
            setHelpScreenVisible(false);
            return;
        }
        setPageIndex(pageIndex + 1);
    }

    return (
    <div className="onboarding">
        <div className="onboarding-box">
        <div className="btn-close-bar">
            <svg className="btn-close" onClick={() => setHelpScreenVisible(false)} width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M24 8L8 24" stroke="#F1EFEB" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M8 8L24 24" stroke="#F1EFEB" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
        </div>
            {dataLoaded &&
        <div className="onboarding-container">
        <img src={BrandLogo} className="brand-logo" alt="Brand logo"/>
        <p className="onboarding-title">How to use the Feel Good Christmas 3D and AR experience</p>
        <OnboardingMobileContent content={onboardingContents[pageIndex]}/>
        <button onClick={buttonClickHandler} className="btn-enter btn-rounded">
            {onboardingContents[pageIndex].button === "next" ? <FontAwesomeIcon icon={faArrowRight} /> : <span>Start <FontAwesomeIcon icon={faArrowRight} /></span>}
        </button>
        <PageDots className="page-dots-container" onboardingContents={onboardingContents} pageIndex={pageIndex}/>
        </div>}
    </div>
    </div>);
}
 
export default Onboarding;